export default __webpack_public_path__ + "static/media/img-20-rune.8063a062.jpg";